import { makeObservable, observable } from "mobx";
import { v4 as uuid } from "uuid";
import { IUser } from "../types/entities";

export class User implements IUser {
  constructor() {
    makeObservable(this);
    this.id = uuid();
  }

  @observable
  id: string = "";

  @observable
  name: string = "";

  @observable
  photo: string = "";

  @observable
  pasKey: string = "";
}
